import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthConstants } from "../config/auth-constants";
import { StorageService } from "../services/storage.service";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class HomeGuard implements CanActivate {
  constructor(
    public storageService: StorageService,
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise((resolve) => {
      this.storageService
        .get(AuthConstants.AUTH)
        .then((res) => {
          this.authService.userPerfil$.next(res.admin);
          if (!res) {
            this.router.navigate([""]);
            resolve(false);
          }
          const requiredRoles = route.data["roles"] as Array<number>;
          if (!requiredRoles || requiredRoles.includes(res.admin)) {
            resolve(true); // Si el usuario tiene el rol permitido, permite la navegación
          } else {
            this.router.navigate([""]);
            resolve(false);
          }
        })
        .catch((err) => {
          resolve(false);
        });
    });
  }
}
